module.exports = __webpack_public_path__ + "img/ahorcado3.ae0ee299.jpg";